import { render, staticRenderFns } from "./OwnershipRole.vue?vue&type=template&id=6ce71809"
import script from "./OwnershipRole.vue?vue&type=script&lang=js"
export * from "./OwnershipRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports